
window.addEventListener("load", function () {
  console.log("Inserting Banner Videos...");

  const banners = [
    {
      sel: ".slideshow-background.slideshow-background--61997138-54a2-4aea-a590-6d3d486252b8",
      src: "https://cdn.shopify.com/videos/c/o/v/53ca3b1f2aa94f93bfbc3938714905ab.mp4",
    },
    {
      sel: ".slideshow-background.slideshow-background--slide_aG6rBf",
      src: "https://cdn.shopify.com/videos/c/o/v/f37d2d21fc844d6a90a92b65adab65e1.mp4",
    },
  ];

  const videos = [];

  function mountVideo(container, src) {
    if (!container) return null;

    // Clear any existing image/content once, not every few seconds
    container.textContent = "";

    const v = document.createElement("video");
    v.src = src;
    v.controls = false;
    v.autoplay = true;
    v.loop = true;
    v.muted = true;          // critical for autoplay on mobile/safari
    v.playsInline = true;    // avoid fullscreen on iOS; helps autoplay
    v.preload = "auto";
    v.style.width = "100%";

    const tryPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    };

    // (Re)try play on key media lifecycle points
    v.addEventListener("loadeddata", tryPlay, { once: true });
    v.addEventListener("canplay", tryPlay);
    v.addEventListener("stalled", tryPlay);
    v.addEventListener("waiting", tryPlay);
    v.addEventListener("suspend", tryPlay);
    v.addEventListener("error", () => {
      // soft reload on error without recreating the element
      v.load();
      tryPlay();
    });

    container.appendChild(v);
    tryPlay();

    return v;
  }

  // Mount once
  banners.forEach(({ sel, src }) => {
    const container = document.querySelector(sel);
    if (!container) {
      console.error("Banner container not found for selector:", sel);
      return;
    }
    const v = mountVideo(container, src);
    if (v) videos.push(v);
  });

  // Watchdog: check if currentTime advances; only intervene if truly stuck
  const lastTime = new WeakMap();
  const stuckCount = new WeakMap();

  function watchdogTick() {
    videos.forEach((v) => {
      if (!v || v.readyState < 2) {
        // not enough data to play; ask the element to reload/play
        v.load();
        v.play().catch(() => {});
        return;
      }

      // If paused by something (tab hidden etc.), just try to resume
      if (v.paused) {
        v.play().catch(() => {});
        return;
      }

      const prev = lastTime.get(v) ?? -1;
      const curr = v.currentTime;

      if (Math.abs(curr - prev) < 0.05) {
        // Looks stuck this tick
        const n = (stuckCount.get(v) ?? 0) + 1;
        stuckCount.set(v, n);

        if (n === 2) {
          // first nudge: tiny seek to unstick decoder without a reload
          try {
            v.currentTime = Math.max(0, curr - 0.01);
          } catch {}
          v.play().catch(() => {});
        } else if (n >= 3) {
          // harder fix: reload the same element (no DOM replace, so no visual jump)
          const keepSrc = v.currentSrc || v.src;
          v.pause();
          v.src = keepSrc; // reassign to force a fresh request
          v.load();
          v.play().catch(() => {});
          stuckCount.set(v, 0);
        }
      } else {
        // advancing fine
        stuckCount.set(v, 0);
      }

      lastTime.set(v, curr);
    });
  }

  // Check every 2s; small and cheap
  setInterval(watchdogTick, 2000);

  // Bonus: handle tab visibility to avoid weird states
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      videos.forEach((v) => v.pause());
    } else {
      videos.forEach((v) => v.play().catch(() => {}));
    }
  });
});

// Output full customer object
console.log('Customer Object:', null);

// Output just the tags
console.log('Customer Tags:', null);

// Check if customer exists
console.log('Is Logged In:', false);

// Check specific tag
console.log('Has Trade Trusted Tag:', false);

// Store in window variables for easy debugging
//window.customerData = null;
//window.customerTags = null;
//window.hasTradeAccess = false;

console.log('Window variables set - check window.customerData and window.customerTags');
/*
function hideRestrictedContent() {
  if (!window.hasTradeAccess) {
    document.querySelectorAll('a[href*="vivotek"]').forEach(link => {
      const menuItem = link.closest('li, .menu-item, [role="menuitem"]');
      if (menuItem) {
        menuItem.style.display = 'none';
      }
    });
    
    document.querySelectorAll('li.snize-product-tag-brand_vivotek').forEach(item => {
      item.style.display = 'none';
    });
    
    if (window.location.pathname.includes('vivotek') || location.search.includes("viv")) {
      window.location.href = '/';
    }
    
    document.addEventListener('click', (e) => {
      if (e.target.href && e.target.href.includes('vivotek')) {
        e.preventDefault();
        window.location.href = '/';
      }
    }, true);
  }
}

hideRestrictedContent();

let debounceTimer;
const observer = new MutationObserver(() => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(hideRestrictedContent, 100);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});*/